// Règles du suivi des logs : source unique pour le bouton "Règles" de l'écran
// et la page docs/fonctionnel/suivi-des-logs.md (BI-669).

export const SEUIL_GRISE_DEFAUT = 24;
export const CONSERVATION_MOIS = 13;

const seuil = (h) => {
  const n = Number(h);
  return Number.isFinite(n) && n > 0 ? n : SEUIL_GRISE_DEFAUT;
};

export const REGLE_SOURCE =
  "Source : consolidation quotidienne à 15h ; uniquement les builds terminés (running = false) du mois courant et du mois précédent ; chaque build est traité une seule fois. Les builds en cours n'apparaissent pas encore.";
export const REGLE_ERREURS =
  "Erreurs : build avec au moins 1 log ERROR ou ERROR_R.";
export const REGLE_WARNINGS =
  "Warnings : build avec au moins 1 log WARNING, WARNING_R ou WARN, sans erreur.";
export const regleGrises = (heures) =>
  `Builds grisés : dernier build d'un traitement encore en cours depuis plus de ${seuil(
    heures
  )} heures (seuil réglable, valeur actuelle : ${seuil(
    heures
  )} h) ; les anciens builds bloqués suivis d'un build plus récent ne comptent pas.`;
export const REGLE_ECART_MAP =
  "Écart avec la map : la map montre aussi les builds en cours ; le suivi ne les reprend qu'une fois terminés, d'où un décalage possible jusqu'à la consolidation suivante (15h).";
export const REGLE_ACQUITTEMENT =
  "Acquittement : À traiter / Pris en charge / Résolu + commentaire ; auteur et date tracés.";
export const REGLE_FILTRE_DATE =
  "Filtre Début / Fin : date et heure à la minute (heure de Paris), sur la date de fin du build ; sans heure, 00:00 pour le début et 23:59 pour la fin ; une borne seule suffit. Onglets Erreurs et Warnings.";
export const REGLE_EXPORT =
  "Export CSV : bouton « Exporter en CSV », sur les trois onglets, avec les filtres appliqués ; une ligne par message de log pour Erreurs et Warnings, une ligne par build pour Builds grisés ; sans limite de lignes, un export volumineux peut être long.";
export const REGLE_REGROUPEMENT =
  "Regrouper par traitement : une ligne par traitement, triée par score décroissant (score = 3 × builds en erreur + 2 × builds grisés + 1 × builds en warning) ; builds résolus exclus ; période et statut de suivi ne s'appliquent pas aux builds grisés ; les onglets affichent alors la même vue.";
export const REGLE_CONSERVATION = `Conservation : ${CONSERVATION_MOIS} mois.`;

// Règles affichées dans la modale : { titre, regles: [string] }
export const aideTitre = (heures) => ({
  titre: "Règles du suivi des logs",
  regles: [
    REGLE_SOURCE,
    REGLE_ERREURS,
    REGLE_WARNINGS,
    regleGrises(heures),
    REGLE_ECART_MAP,
    REGLE_ACQUITTEMENT,
    REGLE_FILTRE_DATE,
    REGLE_EXPORT,
    REGLE_REGROUPEMENT,
    REGLE_CONSERVATION,
  ],
});
